import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=a21448ca&scoped=true&"
var script = {}
import style0 from "./carousel.vue?vue&type=style&index=0&id=a21448ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21448ca",
  null
  
)

export default component.exports